/**
 * Easely Registry - Final SPA-Ready Version
 */

class Registry {
  constructor() {
    this.instances = new WeakMap();
    // We maintain a list for hard-clearing during route changes
    this.elements = new Set(); 
  }

  isInitialized(element) {
    return this.instances.has(element);
  }

  register(element, instance) {
    this.instances.set(element, instance);
    this.elements.add(element);
  }

  /**
   * Specifically for SPAs: Kill an animation for a specific element
   */
  destroy(element) {
    const instance = this.instances.get(element);
    if (instance) {
      // Properly kill GSAP Tweens or Timelines
      if (typeof instance.kill === 'function') instance.kill();
      if (instance.scrollTrigger) instance.scrollTrigger.kill();
      
      this.instances.delete(element);
      this.elements.delete(element);
    }
  }

  /**
   * Clear everything (Useful for full page transitions)
   */
  clearAll() {
    this.elements.forEach(el => this.destroy(el));
    this.elements.clear();
  }
}

export const registry = new Registry();